import { render, staticRenderFns } from "./HabitSmallAction.vue?vue&type=template&id=2e7ecda6&"
import script from "./HabitSmallAction.vue?vue&type=script&lang=js&"
export * from "./HabitSmallAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports